import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getAuthCookies } from '@/features/cookies/auth-cookies';
import { getProviderProduct } from '@/features/game-context/platform-helpers';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import {
  geolocationJwtSelector,
  geolocationProgressSelector,
} from '@/features/geolocation/store/geolocation';
import { GeolocationProgress } from '@/features/geolocation/types';
import { useGeolocationHelpers } from '@/features/geolocation/use-geolocation-helpers';

export const useGeolocation = () => {
  const geolocationProgress = useSelector(geolocationProgressSelector);

  const { region, userId, provider } = useSelector(gameContextSelector) ?? {};
  const geocomplyToken = useSelector(geolocationJwtSelector);

  const { authToken: userAuthToken, sessionId } = getAuthCookies() ?? {};

  const { locateUser } = useGeolocationHelpers();

  const triggerGeolocation = useCallback(
    (force?: boolean) => {
      const shouldForceLocatingUser =
        geolocationProgress === GeolocationProgress.NotStarted ||
        force === true;

      const canLocateUser = !!(region && userAuthToken && sessionId && userId);

      const shouldLocateUser = shouldForceLocatingUser && canLocateUser;

      if (!shouldLocateUser) {
        return;
      }

      const domain = getProviderProduct(provider);

      locateUser(
        {
          region,
          sessionId,
          userAuthToken,
          userId,
          geocomplyToken,
        },
        domain,
      );
    },
    [
      userAuthToken,
      sessionId,
      region,
      userId,
      geolocationProgress,
      geocomplyToken,
      locateUser,
      provider,
    ],
  );

  return { triggerGeolocation };
};
